exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label{margin-bottom: 0px !important;}\n.table thead th{vertical-align: top !important;}\n\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/admin/approve-refund/approve-refund.component.css
// module id = ../../../../../src/app/admin/approve-refund/approve-refund.component.css
// module chunks = 39